import cn from 'classnames';
import { ComponentChildren } from 'preact';

import { BaseButton } from '../BaseButton/BaseButton';
import { IconButton } from '../IconButton/IconButton';

interface AudioNativePlayButtonProps {
  href?: string;
  onClick: () => void;
  className?: string;
  children: ComponentChildren;
  size: 'large' | 'medium' | 'small' | 'standard';
}

export const AudioNativePlayButton = ({
  href,
  onClick,
  className,
  children,
  size,
}: AudioNativePlayButtonProps) => {
  if (href) {
    return (
      <BaseButton
        component="a"
        href={href}
        className={cn(
          'vgp-icon-button',
          `vgp-icon-button-size-${size}`,
          'vgp-icon-button-color-primary',
          'vgp-icon-button-variant-rounded',
          className
        )}
      >
        {children}
      </BaseButton>
    );
  }

  return (
    <IconButton
      color="primary"
      size={size}
      variant="rounded"
      onClick={onClick}
      className={className}
    >
      {children}
    </IconButton>
  );
};
